'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Button } from '@/components/ui/button'
import { Logo } from '@/components/brand/logo'
import { Home, FileText, Search, Shield } from 'lucide-react'

export function Navbar() {
  const pathname = usePathname()

  // Don't show navbar on admin pages
  if (pathname?.startsWith('/admin')) {
    return null
  }

  return (
    <nav className="border-b bg-white/80 dark:bg-ink-900/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo - already contains Link, no need to wrap */}
          <Logo />

          {/* Navigation Links */}
          <div className="flex items-center gap-2">
            <Button
              asChild
              variant={pathname === '/' ? 'default' : 'ghost'}
              size="sm"
            >
              <Link href="/">
                <Home className="h-4 w-4 mr-2" />
                Home
              </Link>
            </Button>

            <Button
              asChild
              variant={pathname === '/form' ? 'default' : 'ghost'}
              size="sm"
            >
              <Link href="/form">
                <FileText className="h-4 w-4 mr-2" />
                Apply
              </Link>
            </Button>

            <Button
              asChild
              variant={pathname === '/track-status' ? 'default' : 'ghost'}
              size="sm"
            >
              <Link href="/track-status">
                <Search className="h-4 w-4 mr-2" />
                Track Status
              </Link>
            </Button>

            <div className="ml-4 pl-4 border-l">
              <Button
                asChild
                variant="outline"
                size="sm"
                className="text-brand-600 border-brand-300 hover:bg-brand-50 dark:text-brand-400 dark:border-brand-700 dark:hover:bg-brand-950"
              >
                <Link href="/admin/login">
                  <Shield className="h-4 w-4 mr-2" />
                  Admin
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}
